const settingsRoutes = [
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/Settings.vue"),
    props: (route) => {
      return {
        pathToGoBack: route.query.pathToGoBack,
      };
    },
  },
  {
    path: "/settings/registry",
    name: "SettingsRegistry",
    component: () => import("@/components/setting/store/StoreData.vue"),
  },
  {
    path: "/settings/turns",
    name: "SettingsTurns",
    component: () => import("@/components/setting/store/StoreHours.vue"),
  },
  {
    path: "/settings/aspect",
    name: "SettingsAspect",
    component: () => import("@/components/setting/Theme.vue"),
  },
  {
    path: "/settings/permissions",
    name: "SettingsPermissions",
    component: () => import("@/components/setting/Groups.vue"),
  },
  {
    path: "/settings/controlPanel",
    name: "SettingsControlPanel",
    component: () => import("@/components/setting/store/ControlPanel.vue"),
  },
  {
    path: "/settings/developer",
    name: "SettingsDeveloper",
    component: () => import("@/components/setting/DevelopersSettings.vue"),
  },
];

export default settingsRoutes;
